import { Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import ReduxProvider from './providers/ReduxProvider';
import AppRoute from './routes/AppRoute';
import Snackbar from './components/common/SnackbarMessage';
import { SettingsProvider } from './providers/SettingsProvider';

import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { lazy } from 'react';
const CommonDialogComponent = lazy(() => import("./components/dialog"));
const CommonDrawerComponent = lazy(() => import("./components/drawer"));


const App = () => {
    return (
        <SettingsProvider>
            <ReduxProvider>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <Router>
                        <Routes>
                            <Route path='*' element={<AppRoute />} />
                        </Routes>
                        <CommonDrawerComponent />
                        <CommonDialogComponent />
                    </Router>
                    <Snackbar />
                </LocalizationProvider>
            </ReduxProvider>
        </SettingsProvider>
    )
}

export default App;